import { useShallow } from "zustand/react/shallow"
import { useGridStore } from "../state"
import { Text, Tooltip } from "@mantine/core"
import { SimpleFormulaDto } from "../../../../../orval/gen"

export function FormulaCell({
  formula,
  contractId,
  style,
  className,
}: {
  formula: SimpleFormulaDto
  contractId: number | null
  style?: React.CSSProperties
  className?: string
}) {
  const { result } = useGridStore(
    useShallow((store) => ({
      formulas: store.formulas,
      result:
        store.formulaResults[`${formula.formulaConfigurationId}/${contractId}`],
    }))
  )
  if (contractId === null) {
    return null
  }
  const value = result?.value ? result.value : null
  return (
    <div
      className={className}
      style={{ ...style, backgroundColor: result?.bg || undefined }}
    >
      {result ? (
        <Tooltip label={result.text || ""} style={{ whiteSpace: "pre-line" }}>
          <Text c={result.c || undefined} size="xs">
            {value}
          </Text>
        </Tooltip>
      ) : null}
    </div>
  )
}
